import PropTypes from 'prop-types';
import NavCollapse from './../NavCollapse';
import NavItem from './../NavItem';

/**
 * Nav Group component
 */
const NavGroup = ({ item }) => {
    // If group itself is collapse, render it
    if (item.type === 'collapse') {
        return <NavCollapse menu={item} level={0} />;
    }

    // Otherwise render its children
    return (
        <>
            {item.children.map((menu) => {
                switch (menu.type) {
                    case 'collapse':
                        return <NavCollapse key={menu.id} menu={menu} level={1} />;
                    case 'item':
                        return <NavItem key={menu.id} item={menu} level={1} />;
                    default:
                        return null;
                }
            })}
        </>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object
};

export default NavGroup;